import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
    withCredentials: true
});

export class EventsFetchAPI {

    static async getEventsByBusiness(business_id, token) {
        const res = await server(`/event?business_id=${business_id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

     static async getBranchByEvent(event_id, token) {
        const res = await server(`/branchoffice/by-event?event_id=${event_id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async getEventRules(event_id, token) {
        const res = await server(`/events/rules?event_id=${event_id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

}

